/**
 * The consent line shown beside the phone field when a platform user adds text message as a
 * sign-in method (Settings → Security → "Add phone number").
 *
 * This is carrier evidence for our A2P 10DLC campaign: the public page a reviewer reads
 * (`apps/app/public/sms.html`) quotes it word for word, from the canonical copy in
 * `apps/app/src/constants/smsConsent.ts` (`SECURITY_SMS_CONSENT_TEXT`). It is repeated here
 * only because one app cannot import another's source at runtime.
 * `test/sms-security-consent.guard.spec.ts` fails if the two differ by a single character, so
 * change the canonical copy first, regenerate sms.html (`pnpm run gen:sms-html` in apps/app),
 * then mirror it here.
 */
export const SECURITY_SMS_CONSENT_TEXT =
  'By adding your number you agree to receive security codes by text. ' +
  'Message and data rates may apply. Reply STOP to opt out.'
